import { MESSAGES_DATA } from "./constants";
import { solveMessage } from "../../helpers/solveMessage";
var getUserAccountLinks = function (businessUnit, country, messages) {
    var logoutLink = MESSAGES_DATA.logoutLink, profile = MESSAGES_DATA.loggedMenu.profile, _a = MESSAGES_DATA.unloggedMenu, signIn = _a.signIn, signUp = _a.signUp;
    return {
        logoutLink: {
            href: logoutLink.url,
            label: solveMessage(logoutLink.message, { businessUnit: businessUnit, country: country, messages: messages }),
        },
        loggedMenu: [
            {
                href: profile.url,
                label: solveMessage(profile.message, { businessUnit: businessUnit, country: country, messages: messages }),
            },
        ],
        unloggedMenu: [
            {
                href: signUp.url,
                label: solveMessage(signUp.message, { businessUnit: businessUnit, country: country, messages: messages }),
            },
            {
                href: signIn.url,
                label: solveMessage(signIn.message, { businessUnit: businessUnit, country: country, messages: messages }),
            },
        ],
    };
};
var getUserAccountTexts = function (businessUnit, country, messages) {
    var avatarAltMessage = MESSAGES_DATA.avatarAlt.message, buttonLabelMessage = MESSAGES_DATA.buttonLabel.message;
    var avatarAlt = solveMessage(avatarAltMessage, { businessUnit: businessUnit, country: country, messages: messages });
    var buttonLabel = solveMessage(buttonLabelMessage, { businessUnit: businessUnit, country: country, messages: messages });
    return { avatarAlt: avatarAlt, buttonLabel: buttonLabel };
};
export var getUserAccountData = function (businessUnit, country, messages) { return [
    getUserAccountLinks(businessUnit, country, messages),
    getUserAccountTexts(businessUnit, country, messages),
]; };
//# sourceMappingURL=getData.js.map